import { LayerDetailsReport } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDetailsFetcher'
import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { MapLayerStyles } from '@app/types/mapTypes'
import { PreferencesTypes } from '@app/hooks/usePreferences'
import type { LegendLookup } from '@app/types/layerTypes'
import { useQuery } from '@tanstack/react-query'

export const fetchSettings = async (): Promise<{ tsncs_html: string; db_mode: string }> => {
  const response = await apiClient.get(`${Endpoint.getSettings}`) // or your BASE_API_URL + '/settings'
  return response.data
}

export const fetchLegends = async (): Promise<LegendLookup> => {
  const { data } = await apiClient.get(`${Endpoint.getLegends}`)
  return data
}

export const fetchPreferences = async (): Promise<PreferencesTypes> => {
  const { data } = await apiClient.get<PreferencesTypes>(Endpoint.getClientPreferences)
  return data
}

export const fetchLayerStyles = async (): Promise<MapLayerStyles> => {
  const { data } = await apiClient.get<MapLayerStyles>(Endpoint.getLayersStyle)
  return data
}

export const fetchLayerDetails = async (layerId: string): Promise<LayerDetailsReport[]> => {
  const { data } = await apiClient.get(`${Endpoint.getLayerDetails}/${layerId}`)
  return data
}

export const useFetchLayerDetails = (layerId: string) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated')
  return useQuery({
    queryKey: ['layerDetails', layerId],
    queryFn: () => fetchLayerDetails(layerId),
    enabled: Boolean(isAuthenticated && layerId),
  })
}

export const useFetchSettings = () => {
  const isAuthenticated = localStorage.getItem('isAuthenticated')
  return useQuery<{ tsncs_html: string; db_mode: string }>({
    queryKey: ['settings'],
    queryFn: fetchSettings,
    enabled: Boolean(isAuthenticated),
  })
}

export const useFetchLegends = () => {
  return useQuery<LegendLookup>({
    queryKey: ['legends'],
    queryFn: fetchLegends,
  })
}

export const useFetchLayerStyles = () => {
  return useQuery<MapLayerStyles>({
    queryKey: ['layerStyles'],
    queryFn: fetchLayerStyles,
  })
}

export const useFetchPreferences = () => {
  const isAuthenticated = localStorage.getItem('isAuthenticated')
  return useQuery<PreferencesTypes>({
    queryKey: ['preferences'],
    queryFn: fetchPreferences,
    enabled: Boolean(isAuthenticated),
  })
}

// TODO: Move each fetch to different files
